import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose, Type } from 'class-transformer';

export class OBUStatus extends AdditionalInfoImpl {

    @Expose({ name: 'err_cntr' })
    errorCounter: string;

    @Expose({ name: 'last_err' })
    lastError: string;

    @Expose({ name: 'lost_err' })
    lostError: number;

    @Expose({ name: 'rxd_cntr' })
    rxdControll: number;

    @Expose({ name: 'txd_cntr' })
    txdControll: number;

    @Expose({ name: 'timeout_cntr' })
    timeoutControll: number;

    @Expose({ name: 'last_err_timestamp' })
    @Type(() => Date)
    lastErrorTimestamp: Date;

    @Expose({ name: 'last_lost_timestamp' })
    @Type(() => Date)
    lastLostTimestamp: Date;

    @Expose({ name: 'last_ok_timestamp' })
    @Type(() => Date)
    lastOkTimestamp: Date;

    @Expose({ name: 'manuf' })
    manufacturer: string;

    @Expose({ name: 'model' })
    model: string;

    @Expose({ name: 'serialno' })
    serialNumber: string;

    @Expose({ name: 'revision' })
    revision: string;

    @Expose({ name: 'as_text' })
    asText: string;

    @Expose({ name: 'as_ui32' })
    asui32: string;

    @Expose({ name: 'as_flags' })
    asFlags: any;

    @Expose({ name: 'LN_ID' })
    lineId: string;

    @Expose({ name: 'DR_ID' })
    directionId: string;

    @Expose({ name: 'CurrBS_ID' })
    currBSID: string;

    @Expose({ name: 'CurrDR_BS_No' })
    currDRBSNo: string;

    @Expose({ name: 'LN_No' })
    lNNo: string;

    @Expose({ name: 'CurrBS_Code' })
    currBSCode: string;

    @Expose({ name: 'CourseName' })
    courseName: string;

    @Expose({ name: 'last_err_msg' })
    stp3LastErrorMessage: string;

    @Expose({ name: 'last_err_code' })
    stp3LastErrorCode: string;

    @Expose({ name: 'last_err' })
    stp3LastError: string;

    @Expose({ name: 'last_rqst_timestamp' })
    stp3LastRequestTimestamp: Date;

    @Expose({ name: 'last_err_timestamp' })
    stp3LastErrorTimestamp: Date;

    @Expose({ name: 'last_timeout_timestamp' })
    stp3LastTimeoutTimestamp: Date;

    @Expose({ name: 'last_ok_timestamp' })
    stp3LastOkTimestamp: Date;

    @Expose({ name: 'ln_id' })
    v2xLineId: number;

    @Expose({ name: 'route_id' })
    v2xRouteId: number;

    @Expose({ name: 'calc_prio' })
    calculatedPriority: number;

    @Expose({ name: 'obu_v2x_prio' })
    obuV2xPriority: number;

    @Expose({ name: 'punctuality' })
    punctuality: number;

    @Expose({ name: 'veh_importance' })
    vehicleImportance: number;

    @Expose({ name: 'veh_max_pass_nbr' })
    vehicleMaxPassNumber: number;

}
